<template>
    <div class="component-centered" style="max-width:520px;margin:auto;padding-top:60px;">
        <v-card class="pa-6">
            <h1 class="text-h5 mb-4">Mot de passe oublié</h1>

            <div v-if="messageEnvoye">
                <v-alert type="success" variant="tonal" class="mb-4">
                    {{ messageEnvoye }} Le lien est valable <strong>une heure</strong>.
                </v-alert>
                <v-btn color="primary" block @click="retourConnexion">Retour à la connexion</v-btn>
            </div>

            <div v-else>
                <p class="text-body-2 mb-4">
                    Indiquez l’adresse de votre compte. Si elle nous est connue, vous recevrez un
                    lien pour choisir un nouveau mot de passe.
                </p>

                <v-alert v-if="erreur" type="error" variant="tonal" class="mb-4">{{ erreur }}</v-alert>

                <v-text-field density="compact"
                              variant="outlined"
                              label="Adresse électronique"
                              placeholder="vous@exemple.fr"
                              autocomplete="username"
                              v-model="email"
                              @keyup.enter="envoyer"></v-text-field>

                <v-btn color="primary" block :loading="enCours" @click="envoyer">
                    Envoyer le lien
                </v-btn>

                <div class="text-center mt-4">
                    <a class="text-caption text-decoration-none text-blue" @click="retourConnexion">
                        Revenir à la connexion
                    </a>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
    import MotDePasse from '../script/MotDePasse.js';

    // Demande d'un lien de reinitialisation.
    //
    // Remplace l'ancien forgotPassword(), qui ne faisait qu'un console.log : le lien existait
    // a l'ecran depuis longtemps, il n'y avait rien derriere.
    export default defineComponent({
        data: function () {
            return {
                email: "",
                erreur: null,
                messageEnvoye: null,
                enCours: false
            };
        },
        methods: {
            async envoyer() {
                if (this.enCours) return;

                if (!this.email || this.email.trim() === "") {
                    this.erreur = "Indiquez l'adresse électronique de votre compte.";
                    return;
                }

                this.erreur = null;
                this.enCours = true;
                try {
                    const reponse = await MotDePasse.demanderLien(this.email.trim());
                    if (reponse && reponse.success) {
                        this.messageEnvoye = reponse.resMsg
                            || "Si un compte existe pour cette adresse, un lien vient d'y être envoyé.";
                    } else {
                        this.erreur = (reponse && reponse.resMsg)
                            || "Le service est momentanément indisponible. Réessayez.";
                    }
                } finally {
                    this.enCours = false;
                }
            },
            retourConnexion() {
                this.$router.push({ name: 'Accueil' });
            }
        }
    });
</script>
